module.exports = {
    header: {
        title: '中鑫新材',
        menus: {
            0: { name: '首页' },
            1: { name: '产品中心', children: { 0: '首页', 1: '石塑箱', 2: '石塑建材' } },
            2: { name: '合作共赢' },
            3: { name: '联系我们' },
        },
    },
    footer: {
        title: '中鑫新材料（日照）有限公司',
        address: '地址: 山东省日照市五莲县潮河镇市北经济开发区宝山路东334省道北淮河路南',
        menus: {
            item1: {
                title: '产品中心',
                menus: {
                    0: '石塑箱',
                    1: '石塑建材'
                }
            },
            item2: {
                title: '合作共赢',
                menus: {
                    0: '企业生态理念',
                    1: '合作伙伴招募'
                }
            },
            item3: {
                title: '关于我们',
                menus: {
                    0: '公司简介',
                    1: '荣誉资质',
                    2: '企业文化',
                    3: '联系我们',
                }
            }
        }
    },
    home: {
        content: {
            title: '中鑫新材料（日照）有限公司',
            info1: '中鑫新材料（日照）有限公司成立于2024年3月，是一家聚焦绿色新材料研发与生产的创新型企业，注册资本1亿元，位于山东省日照市北经济开发区。公司依托股东深圳市磊鑫新材料的技术积累与日照本地资源优势，构建了"锯泥回收-材料再造-产品应用”的全链条循环经济体系，深度融入日照石材产业链，致力于推动区域绿色经济转型。',
            info2: '中鑫深耕行业多年，积累了丰富经验，形成独特发展模式与成熟运营体系。作为实力厂家，其汇聚顶尖人才，持续投入研发，以创新技术打造优质产品；凭借先进设备与严格品控，确保产品品质出众。同时，构建全流程专业服务体系，以客户需求为导向提供贴心服务。未来，中鑫将依托经验优势，持续创新，携手伙伴为客户与行业创造更大价值。',
            info3: '公司聚焦两大核心产品方向：一是装修建材产品，涵盖SPC石晶墙板、uv板、石塑墙板、碳晶板、户外地板以及门板等新型建材。二是应用广泛的石塑箱系列，包含周转箱、包装箱、瓶托和刀卡等多种包装产品；公司始终秉持“科学创新，凝聚新材”，专注于将固废转化为高价值新材料，致力于成为世界无机环保石塑行业领跑者。',
            info4: '了解更多信息',
        },
        product: {
            title: '产品中心',
            more: '查看全部',
            openInfo: '查看详情',
            productList: {
                0: {
                    title: '石塑箱',
                    content: '石塑箱具备多重优势:防水防潮、抗压耐摔、耐-30°C至 80°C温差，防护性强;可循环使用数十次，折叠后省空间，轻量化设计降本增效;有密封防尘、食品级安全等功能，支持标识定制与自动化适配。适用于多场景，是绿色高效的物流包装优选。',
                },
                1: {
                    title: '石塑建材',
                    content: '石塑建材具备多重优势:高强度且轻质抗冲击、耐腐蚀，耐久性远超传统材料;导热导电性能优异，可用于节能地暖、智能温控等场景;具有抗菌抑菌特性，适配医疗、食品等高卫生需求环境;绿色环保，材料无毒可回收，且能提升建筑保温隔热效果，降低能耗，助力实现低碳建筑与智能化集成。',
                }
            }
        },
        consult: {
            text1: '现在咨询',
            text2: '即可为您免费提供相应的解决方案详情资料！',
            text3: '服务热线',
            text4: '立即咨询',
        },
        receive: {
            text1: '申请合作',
            text2: '慎易以避难 敬细以远大',
            text3: '请输入联系电话',
            text4: '请输入姓名',
            text5: '立即申请',
        }
    },
    weedingRobot: {
        title: '中空板',
        info1: '中空板是一种多材质复合的新型环保板材，是一种无毒、无味，防潮湿、耐腐蚀，质量轻、抗拉伸、强度高，颜色多样的新型材料；是一种环保无公害、可回收循环使用的绿色环保材料。',
        info2: '中空板是由树脂(聚丙烯pp)、功能性添加剂(防静电添加剂、阻燃剂、抗紫外线剂、色母粒等）和加工助剂（润滑剂、增韧剂、填充剂等）三大基材经过拉板设备共挤形成中空结构的板材，由于功能性添加剂及加工助剂品种及添加比例不同，产出不同功能性中空板板材，例如普通中空板、静电中空板、抗UV中空板、导电中空板等。中空板主要应用于电子、家电、包装、汽车配件、广告装潢、邮政、食品、医药、文化用品等各种行业领域。',
        title1: '功能特点',
        menus: {
            0: '防水防潮',
            1: '抗压抗摔',
            2: '耐高温/低温',
            3: '食品级',
        },
        content: '石塑箱具备多重优势:防水防潮、抗压耐摔、耐-30°C至 80°C温差，防护性强;可循环使用数十次，折叠后省空间，轻量化设计降本增效;有密封防尘、食品级安全等功能，支持标识定制与自动化适配。适用于多场景，是绿色高效的物流包装优选。',
        title2: '支持定制·更多推荐',
        custList: {
            0: '周转箱',
            1: '水果箱',
            2: '发货箱',
            3: '储物箱',
        },
        title3: '中空板刀卡内材',
        content3: '中空板刀卡作为提高零部件和物品在运输过程中的防震动、防刮伤、防油污、防 灰尘的保护材料，常用的材料组合有中空板+中空板、中空板+植绒(绒布)、中空板+珍珠棉(EPE) 、 中空板+发泡材料(EVA) 、中空板+PE袋等等。',
        title4: '中空板周转箱',
        content4: '中空板周转箱是由中空板和各种零配件组装而成的箱子，可根据客户提供的尺寸设计制作，做到最合理装载，并可多箱重叠零部件储存量，重复循环使用，达到节约生产成本的目的。',
    },
    transportRobot: {
        title1: '功能特点',
        menus: {
            0: '防水防潮',
            1: '抗压抗摔',
            2: '耐高温/低温',
            3: '防刮擦',
        },
        content: '石塑建材具备多重优势:高强度且轻质抗冲击、耐腐蚀，耐久性远超传统材料;导热导电性能优异，可用于节能地暖、智能温控等场景;具有抗菌抑菌特性，适配医疗、食品等高卫生需求环境;绿色环保，材料无毒可回收，且能提升建筑保温隔热效果，降低能耗，助力实现低碳建筑与智能化集成。',
        title2: '支持定制·更多推荐',
        custList: {
            0: '墙板',
            1: '地板',
            2: '天花板',
            3: '踢脚线',
        }
    },
    cooperation: {
        title1: '我们的优势',
        advantageList: {
            0: {
                title: '技术创新引领行业变革',
                content: `技术创新引领行业变革公司以三维石墨烯无机环保箱为核心产品，通过自主研发的石墨烯高分子新材料技术，成功将石材加工废弃物锯泥等无机粉体占比提升至 70% 以上。这一突破性技术不仅解决了传统石材产业的环境污染问题，更赋予产品防水防潮、抗压耐撕裂等优异性能，同时实现原料成本降低与产品强度提升的双重突破。`,
            },
            1: {
                title: '绿色制造与可持续发展',
                content: `绿色制造与可持续发展全程贯彻环保理念，公司生产过程实现无废无污染，从原料选择到工艺设计均严格遵循生态标准。三维石墨烯环保箱可完全降解，契合全球减塑趋势，已成为替代传统塑料包装的优选方案。这种绿色发展模式不仅响应国家"双碳"战略，更赢得了国内外客户的高度认可。`,
            },
            2: {
                title: '一站式产业链优势',
                content: `依托股东深圳市磊鑫新材料的技术积累与日照本地资源优势，公司打造了从原料处理到成品生产的一站式产业链。位于日照市北经济开发区的生产基地，紧邻石材产业集群，既保障了低成本原料供应，又通过规模化生产实现高效交付能力。目前，公司生产线已实现稳定运行，产品广泛应用于物流包装、建筑材料等领域。`,
            }
        },
        title2: '加盟流程',
        franchiseList: {
            0: {
                title: '提交合作意愿',
                content: `拨打热线或在线申请`,
            },
            1: {
                title: '确定合作关系',
                content: `提交合作意向后，会有相关人员<br/>与您联系，洽谈合作`,
            },
            2: {
                title: '合作成功',
                content: `签约完成`,
            }
        },
        title3: '欢迎留言',
        title4: '我们承诺24小时内与您取得联系',
        text1: '请输入您的姓名',
        text2: '请输入您的电话',
        text3: '请输入您的所属城市',
        text4: '意向产品（多选）',
        text5: '石塑箱',
        text6: '石塑建材',
        text7: '其他',
        text8: '合作模式',
        text9: '购买',
        text10: '租赁',
        text11: '提交',
        label1: '姓名',
        label2: '电话',
        label3: '城市',
    },
    aboutUs: {
        criterion: {
            title: '检测标准',
            title1: '欧盟标准 ROHS 标准检测报告',
            content1: '据欧盟ROHS指令2002/95/EC的重订指令 2011/65/EU附录 的限值要求,  测试产品石塑母粒中重金属及多溴联苯(PBB)多溴二苯醚(PBDE)的含量证明石塑母粒不含常见重金属物质及致癌物质。',
            title2: '欧盟标准 REACH 高危物质检测报告',
            content2: '根据欧器第190712006号REACH法规， 对138种高关注物质(直接有害物质， 间  接有害物质)进行稀分测试，产品石塑母粒中测试中的高关注物浓度均  符Reach国际标准 。 证明石塑母粒不含任何有害人体健康的物质。',
        },
        patent: {
            title: '产品专利',
            content: '新型材料课题开展多项自主研发并获得多项专利知识产权,  现研发成果已实现工业化生产。致力打造新材料全产业生态链,  技术遥遥领先国内箱体发展5年。'
        },
        developList: {
            0: '核心技术与产品创新',
            1: '循环经济与绿色制造',
            2: '产业协同与战略布局',
            3: '公司全景',
            4: '团队/研发场景',
            5: '产品实拍/应用场景',
            6: '绿色生产过程',
            7: '资质与认证',
            8: '政企合作/行业活动',
        },
        title: '联系我们',
        text1: '电话',
        text2: '网址',
        text3: '地址：山东省日照市五莲县潮河镇市北经济开发区宝山路东334省道北淮河路南'
    },
    Specifications: {
        title: '产品规格性能介绍',
        title1: 'SPC 石晶墙板',
        content1: '1.生产原材料：高纯度碳酸钙石粉和全新PVC 树脂高温共挤一体成型，无胶水粘合。</br>' +
            '2.常规生产规格：标准幅宽600/1220mm；常规长度 2440mm/2800mm/3000mm，量大长度可定制。</br>' +
            '3.常用厚度：4mm。</br>' +
            '4.密度：1.8~2.05 g/ cm³（1800~2050kg/ m³）。' +
            '5.强度指标：抗弯强度≥35MPa、抗冲击强度≥12kJ /㎡、锁扣拉力≥550N，抗挤压、不易断裂凹陷。</br>' +
            '6.综合性能：零吸水率；国标B1 级难燃，离火自熄；E0 / ENF 级无甲醛；热胀冷缩率≤0.05 %，适配地暖；隔音 30dB；耐酸碱、防霉防虫；表面莫氏硬度 4~5 级。</br>' +
            '7.核心优势：毛坯墙锁扣快装，缩短70 % 工期；适配厨卫、地下室、沿海潮湿环境；表面防油污易清洁；家装工装通用，无放射性。',
        title2: 'UV 装饰板',
        content2: '1.生产原材料：石灰石钙粉和全新 PVC 树脂、环保功能助剂；五层结构：PE 保护膜 + UV 耐磨固化层 + 高清印花装饰膜 + 高密度石塑基材 + 平衡封底膜。</br>' +
            '2.常规生产规格：1220×2440mm、1220×2800mm、1220×3000mm，长度支持定制裁切。</br>' +
            '3.常用厚度：2.0mm~4mm；表面硬度 3H~6H。</br>' +
            '4.密度：1.9~2.1 g/cm³（1900~2100kg/m³）。</br>' +
            '5.强度指标：表层耐刮耐磨、抗冲击不开裂，板材收缩率低，不易起拱翘边。</br>' +
            '6.综合性能：全防水防潮，长期泡水不发胀、不发霉；国标 B1 级防火阻燃，E0/ENF 级零甲醛、无辐射；温湿度变化不变形；表面致密防污，油污污渍一擦即净。</br>' +
            '7.核心优势：免钉胶直接粘贴，裁切简单、施工快速；家装工装墙面、背景墙通用；使用寿命 15 年以上，防水防潮性能优于木饰面，性价比远高于天然大理石。',
        title3: 'WPC 石塑墙板',
        content3: '1.生产原材料：碳酸钙和 PVC 树脂，高温一体挤出成型。</br>' +
            '2.常规生产规格：宽度600/400/，常规长度2440mm/2800mm/3000mm，支持加长定制。</br>' +
            '3.常用厚度：8mm。</br>' +
            '4.密度：1.2~1.6 g/cm³（1200~1600kg/m³）。</br>' +
            '5.强度指标：抗弯28~33MPa，抗冲击≥9kJ/㎡，握钉力优秀，可锯、钻、二次加工。</br>' +
            '6.综合性能：吸水率≤0.2%，B1 级阻燃，E0 环保；温湿度变化不易变形；隔音 28-32dB，防虫耐腐蚀，耐温 - 20℃~100℃。</br>' +
            '7.核心优势：性价比优于实木护墙板；干法快装，无需墙面批腻子；一楼、南方潮湿环境专用；木纹、石纹、纯色款式丰富，日常湿布擦拭即可。',
        title4: 'BCC 碳晶板木饰面',
        content4: '1.生产原材料：钙粉、高分子PVC、碳晶改性粉体、热压装饰膜高温复合。</br>' +
            '2.常规生产规格：宽1220mm，常规长度 2440mm/2800mm/3000mm，可做一板到顶超长板材。</br>' +
            '3.常用厚度：5mm、8mm。</br>' +
            '4.密度：0.65~0.85 g/cm³。</br>' +
            '5.强度指标：抗弯≥30MPa，120 天温湿度循环不开裂起拱，表面莫氏硬度 4~5 级。</br>' +
            '6.综合性能：吸水率＜0.5%，B1 阻燃（铝蜂窝基材可达 A 级）；ENF 级近乎零甲醛；具备吸附净化、隔音功能，耐温 - 30℃~120℃。</br>' +
            '7.核心优势：无缝整墙极简效果，毛坯卡扣快速安装；酒店、会所、高端家装首选；即装即住，防潮防霉。',
    }

}